import { FC } from "react";
import { IconButton, Typography } from "@mui/material";
import { ArrowDonwIcon } from "../../../../../../assets/icons";
import logoDark from "../../../../../../assets/logo_dark.svg";
import logoLight from "../../../../../../assets/logo_light.svg";
import { useCurrentTheme } from "../../../../../../theme/theme";
import HeaderWrapper from "./MenuHeaderWrapper";

interface Props {
	menuIsOpen: boolean;
	closeMenu: () => void;
}

const MenuHeader: FC<Props> = ({ closeMenu, menuIsOpen }) => {
	const { theme } = useCurrentTheme();

	return (
		<HeaderWrapper>
			{menuIsOpen && (
				<Typography>
					{theme.palette.mode === "dark" ? (
						<img src={logoLight} width={"auto"} height={"20px"} alt="logo greerouter" />
					) : (
						<img src={logoDark} width={"auto"} height={"20px"} alt="logo greerouter" />
					)}
				</Typography>
			)}
			<IconButton
				onClick={closeMenu}
				sx={{
					border: "1px solid",
					width: "24px",
					height: "24px",
					borderRadius: 1,
					borderColor: theme.palette.primary.main,
				}}
			>
				<ArrowDonwIcon sx={{ transform: "rotate(90deg)" }} />
			</IconButton>
		</HeaderWrapper>
	);
};

export default MenuHeader;
